// extracted by mini-css-extract-plugin
export default {"grantList":"GrantList_grantList__HVMSK"};